import(/* webpackMode: "eager", webpackExports: ["MainLayout"] */ "/home/runner/work/customer-frontend/customer-frontend/src/app/main-layout.tsx");
